import { useI18n } from "vue-i18n";
function interpolateFallback(template, params) {
    if (!params)
        return template;
    return Object.entries(params).reduce((value, [name, replacement]) => value.replace(new RegExp(`\\{${name}\\}`, "g"), String(replacement)), template);
}
function isTranslateParams(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
export function useItineraryI18n() {
    const { t, te, locale } = useI18n();
    function translate(key, paramsOrFallback, fallback) {
        const params = isTranslateParams(paramsOrFallback)
            ? paramsOrFallback
            : undefined;
        const fallbackText = typeof paramsOrFallback === "string" ? paramsOrFallback : fallback;
        if (typeof te === "function" && te(key)) {
            return String(t(key, params));
        }
        const translated = String(t(key, params));
        if (translated !== key)
            return translated;
        return fallbackText
            ? interpolateFallback(fallbackText, params)
            : translated;
    }
    return {
        locale,
        t: translate,
        te,
    };
}
